/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import axios from "axios";
import Cookie from "../lib/Cookie";
import { getBizName, getLogo, getStyle, setAuthen, setBizID, setBusinessName, setCurrentRole, setLogo, setRoles, setServices, setStyle } from "../libs/todoSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { Button } from "@mui/material";
import fontColor from "../lib/fontColor";
import { useEffect } from "react";
import { Card, Hidden } from "@material-ui/core";
import { logoutSession } from "../lib/logoutRedirect";


const Completed = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [cookie, setCookie, removeCookie] = useCookies(['account', 'new_user'])
  const style = useSelector(getStyle)
  const params = useParams()
  const logo = useSelector(getLogo)
  const business_name = useSelector(getBizName)
  useEffect(() => {
    getPrefixDetail()
  }, [])
  const getPrefixDetail = async () => {
    try {
      const { data, status } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix?prefix=${params.prefix}`,
      })
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setBizID({
          biz_id: data.data.businessID
        }))
        dispatch(setStyle({
          style: data.data.themes.style
        }))
        dispatch(setServices({
          services: data.data.services
        }))
        if (data.data.services) {

        } else {

        }
      }
      getDataLogo(data.data.businessID)
      getRoles(data.data.businessID)
      getBusinessName(data.data.businessID)
    } catch ({ response }) {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }

  const getRoles = async (business_id) => {
    try {
      const { data, status } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/roles?business_id=${business_id}`,
      })
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setRoles({
          roles: data.data
        }))
        const resolvedRole = data.data.includes('RA') ? 'RA' : data.data.includes('owner') ? 'owner' : data.data[0]
        dispatch(setCurrentRole({
          current_role: resolvedRole
        }))
      }
    } catch (err) {
      const status = err?.response?.status
      if (status === 401) {
        localStorage.removeItem('account')
        localStorage.removeItem('policy_accept')
      }
      if (status === 403) {
        navigate('/forbidden')
      }
    }
  }
  const getDataLogo = async (business_id) => {
    try {
      const { data, status } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/logo?business_id=${business_id}`,
      })
      dispatch(setLogo({
        logo: data.data
      }))
    } catch (err) {
      const status = err?.response?.status
      if (status === 401) {
        localStorage.removeItem('account')
      }
    }

  }

  const getBusinessName = async (business_id) => {
    try {
      const { data, status } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/biz-name?business_id=${business_id}`,
      })
      dispatch(setBusinessName({
        business_name: data.data.businessName
      }))
    } catch (err) {
      const status = err?.response?.status
      if (status === 401) {
        localStorage.removeItem('account')
      }
    }
  }

  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: params.prefix,
    })
  };
  return (
    <div
      style={{
        // background: `linear-gradient(90deg, ${style.primary_color} -2.5%, ${style.primary_color} 22.06%, ${style.primary_color} 48.22%, ${style.primary_color} 76.51%, ${style.primary_color} 100%)`, 
        background: '#F8F9FA',
        height: '100vh',
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
        <img
          // src="/logo.png"
          src={`data:image/png;base64, ${logo}`}
          onError={(e) => {
            e.target.src = '/one-platform.png'
          }}
          alt=""
          style={{
            maxHeight: '70px',
            maxWidth: '70px',
          }}
        />
        <span
          style={{
            fontWeight: '600',
            color: fontColor(style.primary_color),
            padding: '10px',
          }}
        >
          {business_name}
        </span>

        {localStorage.getItem('account') &&
          <span
            style={{
              float: 'right',
            }}
          >
            <Button
              onClick={() => {
                logout()
              }}
              sx={{
                color: fontColor(style.secondary_color),
                justifyContent: 'center',
                alignItems: 'center',
                padding: '9px 15px',
                gap: '10px',
                width: '120px',
                height: '36px',
                background: `${style.secondary_color} !important`,
                borderRadius: '6px',
                float: 'right',
              }}
            >
              ออกจากระบบ
            </Button>
          </span>
        }
      </div>
      <Hidden xsDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_login_RA_new.png"
            style={{
              position: 'absolute',
              // width: '670.75px',
              // height: '650.54px',
              width: '780px',
              height: '780px',
              top: '200px',
              marginRight: '70px',
              zIndex: '1'
            }}
            alt=''
          />
          <img
            src="/img_login_RA_vector.png"
            style={{
              position: 'absolute',
              top: '270px',
              zIndex: '0',
              height: '-webkit-fill-available'
            }}
            alt=''
          />
        </div>
      </Hidden>
      <div style={{
        letterSpacing: '0.02em',
        padding: '100px 80px',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <Card
          style={{
            width: '467px',
            color: '#053075',
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '32px',
            padding: '48px 40px',
            zIndex: '1',
          }}>
          <div style={{ fontSize: '40px', fontWeight: '300' }}><span>เสร็จเรียบร้อย</span></div>
          <div style={{ fontSize: '30px', paddingTop: '10px', fontWeight: '300' }}><span></span></div>
          <div style={{ fontSize: '20px', paddingTop: '15px', fontWeight: '300' }}><span>การตรวจสอบข้อมูลเรียบร้อย<br />ท่านสามารถใช้งานบริการของ CA ได้แล้ว</span></div>
        </Card>
      </div>
    </div>
  )
}

export default Completed